<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/priceManage',title:'价格管理列表'},{title:'定价信息'}]"/>
         <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                	<div class="h-formLine chanpin1">
                                		<el-form :model="zy" label-position="right" ref="zy" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                           <el-form-item label="物料型号" class="h-elformWrap-2" >
                                           		<el-input placeholder="" v-model="zy.materialDescrition" disabled="disabled"></el-input>
                                           </el-form-item>
										   <el-form-item label="物料编码" class="h-elformWrap-2" >
										   		<el-input placeholder="" v-model="zy.materialCode" disabled="disabled"></el-input>
										   </el-form-item>
                                		   <el-form-item label="产品大类" class="h-elformWrap-2">
                                		   		<el-input placeholder="" v-model="zy.levelname==null?'空':zy.levelname" disabled="disabled"></el-input>
                                		   </el-form-item>
                                            <!--<el-form-item label="物料组" prop="materialGroupCode" class="h-elformWrap-2">-->

                                                <!--<brselectlazy category="YLMaterialGroup" :v="zy.materialGroupCode==null?'空':zy.materialGroupCode" v-model="zy.materialGroupCode==null?'空':zy.materialGroupCode" disabled="disabled"></brselectlazy>-->

                                            <!--</el-form-item>-->
                                			<!--<el-form-item label="定价状态" class="h-elformWrap-2">-->
                                                <!--<el-input placeholder="" v-model="zy.setprice==null?'mdm物料':zy.setprice" disabled="disabled"></el-input>-->
                                		  <!--</el-form-item>-->
                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <el-input v-model="zy.typeUserName" oninput="value=value.replace(/[^\d]/g, '')" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.protype"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="毛利率" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.gross"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="成本" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.cost"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="含税单价" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.unitPrice"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="不含税单价" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.unitSellingPrice"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2" prop="xiaoe">
                                                <brselect  category="xiaoe_jishu" :v="zy.xiaoe" v-model="zy.xiaoe"></brselect>
                                                <span v-if="zy.oldXiaoe && zy.oldXiaoe!=zy.xiaoe" style="display:inline-block;float:left;color:#00BFFF;font-weight: normal;font-size: 14px;">
                                                        原数据:{{zy.oldXiaoe=="X"?"是":"否"}} </span>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2" prop="jishu">
                                                <brselect category="xiaoe_jishu" :v="zy.jishu" v-model="zy.jishu"></brselect>
                                                <span v-if="zy.oldJishu && zy.oldJishu!=zy.jishu" style="display:inline-block;float:left;color:#00BFFF;font-weight: normal;font-size: 14px;">
                                                        原数据:{{zy.oldJishu=="X"?"是":"否"}} </span>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <el-select v-model="zy.factory" placeholder="请选择" >
                                                    <el-option
                                                        v-for="(item) in factorylist"
                                                        :key="item.code"
                                                        :label="item.code"
                                                        :value="item.code">
                                                    </el-option>
                                                </el-select>
                                                <span v-if="zy.oldFactory && zy.oldFactory!=zy.factory" style="display:inline-block;float:left;color:#00BFFF; font-weight: normal;font-size: 14px;">
                                                        原数据:{{zy.oldFactory}} </span>
                                            </el-form-item>
                                            <el-form-item label="市场分类" prop="marketType" class="h-elformWrap-2">
                                                <template>
                                                    <brselectlazy category="market_type" :v="zy.marketType" v-model="zy.marketType"  :disabled="!(this.$store.getters.hasRole('swyl_caiwujl'))"></brselectlazy>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="场景分类" prop="sceneCode" class="h-elformWrap-2">
                                                <el-select v-model="zy.sceneCode"  placeholder="请选择" style="width:100%;" @change="getchang"  :disabled="!(this.$store.getters.hasRole('swyl_caiwujl'))" >
                                                    <el-option v-for="item in sceneList" :key="item.sceneCode"
                                                               :label="item.sceneName" :value="item.sceneCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>


                                     </el-form>


                                	</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="h-rowBox ljjtablepaddings4" style="margin-top:30px;padding:0;" v-if="isOemProduct">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>采购价格</h1>
                                </div>
                            </div>
                            <el-table
                                    :data="oemTableData"
                                    stripe
                                    style="width: 100%"
                                    :border="true">
                                <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                </el-table-column>
                                <el-table-column
                                        prop="productName"
                                        label="产品型号">
                                </el-table-column>
                                <el-table-column
                                        prop="productId"
                                        label="产品编码">
                                </el-table-column>
                                <el-table-column
                                        prop="unitPrice"
                                        :label=this.bizhong>
                                </el-table-column>
                                <el-table-column
                                        prop="customerCode"
                                        label="供应商编码">
                                </el-table-column>
                                <el-table-column
                                        prop="customerName"
                                        label="供应商名称">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="h-rowBox ljjtablepaddings4" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>定价信息 <br>

                                    </h1>

                                </div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <span style="display:inline-block;float:left;color:red;font-weight: normal;font-size: 14px;">
                                        备注：粉红色背景标注是表示该次提交的定价信息，其他是历史定价信息</span>
                                </div>
                            </div>
                            <el-table
                                :data="tableData3"
                                style="width: 100%"
                                :row-class-name="tableRowClassName"
                                >
                                <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                                </el-table-column>

                                <el-table-column
                                    prop="leixing"
                                    min-width="170"
                                    label="定价类型"
                                    >
                                    <template slot-scope="scope">
                                        <el-select class="h-tableInput" v-model="scope.row.leixing" style="width: 100%;" placeholder="请选择" @change="changejibiequyu(scope.row)" :disabled="true" :class="{'ljj_selectdisblednone2':true}" >
                                            <el-option  v-for="(item) in dingjialeixing"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="jibie"
                                min-width="170"
                                label="级别/区域">

                                    <template slot-scope="scope">

<!--                                        <brselect :category="scope.row.bianlianga" :v="scope.row.jibie" v-model="scope.row.jibie"  disabled="disabled" ></brselect>-->


                                        <el-select  class="h-tableInput" :class="{'ljj_selectdisblednone2':true}" v-model="scope.row.jibie" style="width: 100%;" placeholder="请选择" :disabled="true" v-if="(scope.row.leixingflag==0||scope.row.leixingflag=='0')">
                                            <el-option
                                                    v-for="(item) in YlSalesAreawaioxiaolist"
                                                    :key="item.code"
                                                    :label="item.name"
                                                    :value="item.code">
                                            </el-option>
                                        </el-select>

                                        <el-select class="h-tableInput" :class="{'ljj_selectdisblednone2':true}" v-model="scope.row.jibie" style="width: 100%;" placeholder="请选择" :disabled="true" v-if="(scope.row.leixingflag==1||scope.row.leixingflag=='1')">
                                            <el-option
                                                    v-for="(item) in customergrouplist"
                                                    :key="item.code"
                                                    :label="item.name"
                                                    :value="item.code">
                                            </el-option>
                                        </el-select>

                                      <el-select  class="h-tableInput" :class="{'ljj_selectdisblednone2':true}" v-model="scope.row.jibie" style="width: 100%;" placeholder="请选择" :disabled="true" v-if="(scope.row.leixingflag==2||scope.row.leixingflag=='2')">
                                        <el-option
                                            v-for="(item) in YlSalesAreawaioxiaolist"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                      </el-select>



                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="bizhong"
                                min-width="170"
                                label="币种">


                                    <template slot-scope="scope" >

                                        <el-select  class="h-tableInput" :class="{'ljj_selectdisblednone2':true}" v-model="scope.row.bizhong" style="width: 100%;" :disabled="true" >
                                            <el-option v-for="item in bizhongListops" :key="item.code"
                                                       :label="item.name" :value="item.code" :disabled="scope.row.leixing==1" >
                                            </el-option>
                                        </el-select>

                                    </template>



                                </el-table-column>
                                <el-table-column
                                prop="jiage"
								min-width="120"
                                label="价格">
                                <template slot-scope="scope">
									<div style="text-align: right;">{{scope.row.jiage}}</div>
                                </template>
                                </el-table-column>
                                <el-table-column
                                        prop="youxiaoqi"
                                        min-width="300"
                                        label="有效期">
                                    <template slot-scope="scope">
										<!-- <el-date-picker
											 class="h-tableInput"
											style="width: 100%;"
											v-model="scope.row.youxiaoqi"
											type="daterange"
											range-separator=" 至 "
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											value-format="yyyy-MM-dd"
											disabled="disabled">
										</el-date-picker> -->
										<div>{{scope.row.youxiaoqi[0]}}至{{scope.row.youxiaoqi[1]}}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
			<div class="" style="margin:20px 0">
			     <pagination :page="q" @query="query"/>
			 </div>
            <div class="h-table h-mrt30 h-rowBox" style="margin-top:0.8rem">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:20px">定价审批</h1>
                    <el-form :model="dingjiashenpi" label-position="right" :inline="true"
                            class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 w-elformWrap-3" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                            <el-input v-model="dingjiashenpi.shenheyijian" placeholder="请输入"
                                      :disabled="taskstatus==1" ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

             <div class="h-txtCenter" style="margin-top: 0.3rem;">
                 <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
                 <el-button class="h-btn h-bBtn h-bgred" @click="tongguobohui(1)" v-if="taskstatus==0">驳回</el-button>
                 <el-button class="h-btn h-bBtn h-bggreen" @click="tongguobohui(2)"  v-if="taskstatus==0">通过</el-button>
                 <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
             </div>
             <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
<!--        &lt;!&ndash; 驳回弹窗 &ndash;&gt;-->
<!--        <el-dialog :visible.sync="refuseDialog" class="h-dialog2" :before-close="xuanmeixuanzhi" @close="gettable">-->
<!--            <div class="h-dialogImg">-->
<!--                <div class="h-disTable">-->
<!--                    <div class="h-tableCell">-->
<!--                        <h1>选择流程</h1>-->
<!--                        <p>Selection process</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


<!--            <div class="h-formLines">-->
<!--                <div style="padding: 40px;">-->
<!--&lt;!&ndash;                    <div>选择流程</div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="bgImgImg" >&ndash;&gt;-->

<!--&lt;!&ndash;                        <textarea  class='textarea' @scroll='textsrc' v-model='Headquarters' ref='Headquarters' maxlength="150"></textarea>&ndash;&gt;-->


<!--                        <el-select v-model="liuchengid" placeholder="请选择" style="width:7rem;" @change="fuzhi">-->
<!--                            <el-option v-for="item in xuanzeliuchengop" :key="item.value"-->
<!--                                       :label="item.label" :value="item.value">-->
<!--                            </el-option>-->
<!--                        </el-select>-->


<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                </div>-->
<!--&lt;!&ndash;                <div style="display:flex;justify-content:center">&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-button class="h-btn h-formBtn" type="primary">确定</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--            </div>-->


<!--        </el-dialog>-->
    </div>
</template>
<script>
import ss from '../../api/SystemService';
export default {
    data(){
        let that=this
        return{
            YlSalesAreawaioxiaolist:[],
            customergrouplist:[],
            bizhongListops:[],
            oemTableData: [],
            taskstatus:'',
            showhistory:false,
            isOemProduct: false,
            materialOemCode: '',
            serviceProductsType:'',
            //物料id
            ywid:'',
            //taskid
            taskid:'',
            Headquarters:'',
            refuseDialog:true,
            //流程id
            instid:'',
            liuchengid:'',
            xuanzeliuchengop:[],
            rules: {
                shenheyijian: [
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],

            },
            show:true,
            icon:[
                {
                    title:'型号部门',
                    isactive:0,
                    iscircle:0,
                    time:'2019/09/10 18:00:00',
                },
                {
                    title:'采购经理',
                    isactive:0,
                    iscircle:0,
                    time:'2019/09/10 18:00:00',
                },
                {
                    title:'小微主',
                    isactive:0,
                    iscircle:0,
                    time:'2019/09/10 18:00:00',
                },
                {
                    title:'财务经理',
                    isactive:0,
                    iscircle:3,
                    time:'2019/09/10 18:00:00',
                }
            ],
            dingjiashenpi:{
                shenheyijian:'',
            },
            fanhuizancun:[],
            bianlianga:'',
            //要删除的
            yaoshanchude:[],
            //查询定价集合
            dingjiajihe:[],
            q: {
                pageSize: 100,
                pageNo: 1,
                total: 0,
            },
            //币种
            bizhonglist:[],
            //产地
            factorylist:[],
            //区域
            YlSalesArea:[],
            //前页转发内容
            chanpinneirong:{},
            //定价id
            dingjiaid:'',
            dingjialeixing: [{
                value: '',
                label: '--请选择--'
            },{
                value: 2,
                label: '外贸'
            },{
                value: 1,
                label: '内销'
            }, {
                value: 0,
                label: '外销'
            }],
            jibie: [{
                value: '',
                label: '--请选择--'
            },],
            quyu: [{
                value: '',
                label: '--请选择--'
            },],
            //配置集合
            configlist:{},
            bizhongop:[{
                value: '',
                label: '--请选择--'
            },],
            all: "全部",
            formInline:{
				names:'',
                starttime: '',
                endtime:'',
                areaName:''
            },
			options1:[{
			    value: '选项1',
			    label: '渠道1'
			    }, {
			    value: '选项2',
			    label: '渠道2'
			    }],
            pickerOptions:{
                disabledDate(time){
                    let endDate=that.formInline.endtime;
                    let startDate=that.formInline.starttime;
                    return time.getTime()<new Date(startDate).getTime() || time.getTime()>=new Date(endDate).getTime()
                }
            },
            options2:[],
			zy: {},
            tableData3: [
                {
                    leixing:'',
                    jibie: '',
                    bizhong: '',
                    jiage: '',
                    youxiaoqi: ['',''],

                }
            ],
            optionsCustomer:[],
            optionsAgent:[],
            userCarePlan:{},
			totalbizhong:'',
			totalbizhong2:'',
			totalbizhong3:"",
			totalbizhong4:"",

            sceneList:[],//场景
            bizhong:null,
            fwProdcut:{
                productName:null,
                productId:null,
                currency:null,
                unitPrice:null,
                customerName:null,
                customerCode:null,
            },
        }
    },
    mounted(){

    },
    created(){

        this.YlSalesAreawaioxiaolist = this.$store.getters.dictlist("neibu_haiwai_area");

        this.customergrouplist = this.$store.getters.dictlist("customer_group");
        //产地
        this.factorylist = this.$store.getters.dictlist("factory");

        this.bizhongjiazai();

        this.options2 = this.$store.getters.dicts["userCareType"];

        // //前页信息
        // this.chanpinneirong = this.$router.history.current.query;

        // //物料号
        // this.dingjiaid = this.$router.history.current.query.materialCode;

        // //上头内容
        // this.zy = this.$router.history.current.query;

        //业务id
        this.ywid = this.$router.history.current.query.ywid;

        //taskid
        this.taskid = this.$router.history.current.query.taskid;

        this.taskstatus = this.$route.query.taskstatus;

        //instid
        this.instid = this.$router.history.current.query.instid;

        console.log(this.$route.query,'为什么')


        this.chushixuanze(this.$router.history.current.query.ywid);

        // this.fff();
        //
        // this.huoqupeizhi();
        //
        // this.query(this.$router.history.current.query);

    },
    methods:{
        tableRowClassName({row, rowIndex}) {
            console.log(arguments)
            if (row.nowshenpflag == '1') {
                return 'warning-row';
            }
            return '';
        },
        chakanOemOrice() {
            //先判断是否是售后增值服务产品
            if(this.serviceProductsType != null && this.serviceProductsType != '' && this.serviceProductsType == '售后增值服务'){
                ss.chanpin.checkCgprice(this.materialOemCode).then(rd => {
                    if(rd.f){
                        let data = rd.msg;
                        for(var i = 0;i<data.length;i++){
                            let cgProduct = data[i];
                            this.fwProdcut.productId = cgProduct.prodcode;
                            this.fwProdcut.productName = cgProduct.promodel;
                            this.fwProdcut.unitPrice = cgProduct.totalPrice;
                            this.fwProdcut.currency = cgProduct.currency;
                            if(cgProduct.currency != 'CNY'){
                                this.bizhong = '采购价格（' + cgProduct.currency + '）';
                            }else {
                                this.bizhong = '采购价格（RMB）';
                            }
                            this.fwProdcut.customerCode = cgProduct.supplierCode;
                            this.fwProdcut.customerName = cgProduct.supplierName;
                            this.oemTableData.push(this.fwProdcut)
                        }
                        console.log(this.oemTableData)
                    }
                })
            }else {
                ss.chanpin.selectProPrice(this.materialOemCode).then(rd => {
                    this.oemTableData = rd;
                    if(this.oemTableData[0].currency != 'CNY'){
                        this.bizhong = '采购价格（' + this.oemTableData[0].currency + '）';
                    }else {
                        this.bizhong = '采购价格（RMB）';
                    }
                })
            }

        },
        //币种加载
        bizhongjiazai(){
            ss.Dictservice.listbycategory("YLCurrency").then(rd=>{
                console.log(rd,'字典结果')
                this.bizhongListops = rd;
            })
        },
        viewpress(){
            this.showhistory = true;
        },
        //选没选值
        xuanmeixuanzhi(done){
            this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                .then(_ => {
                    if(!this.instid){
                        this.$msg.msge('请先选择')
                        console.log('请先选择')
                    }else{
                        done();
                    }
                })
                .catch(_ => {

                });
        },
        //选择流程，将被选中流程id存起来
        fuzhi(){
            this.instid = this.liuchengid;
            console.log(this.liuchengid)
        },
        //关闭选择框加载数据
        gettable(){
            this.query();
        },
        hidden(index){
            if(index === 6){
                this.show = fasle;
            }
        },
        textsrc() {

            this.$refs.Headquarters.scrollTo(0, 0);
            let LineNumber = this.$refs.Headquarters.scrollHeight / 58;
            console.log(this.state)
            if (LineNumber => 3) {
                this.state = false;
            } else {
                this.state = true;
            };
            !this.tiemr && !this.state && this.tiemer();
            this.tiemr && this.state && clearInterval(this.tiemr);
            console.log(this.state,"+++++NNNNN")
            if (this.state) {
                this.tiemr = null;
            }
        },
        tiemer() {
            this.tiemr = setInterval(() => {
                if (this.$refs.Headquarters.scrollHeight /58 == 3) {
                    clearInterval(this.tiemr)
                    this.tiemr = null
                    this.state = true
                }
            }, 10);
        },
        //初始选择流程
        chushixuanze(q){
            var shenpibanben = {
                shenpibanben:q,
            }
            ss.chanpin.xuanzeliucheng(shenpibanben).then(rd => {
                //物料上部信息
                this.zy = rd.zy;
                this.materialOemCode = this.zy.materialCode;
                this.serviceProductsType = this.zy.serviceProductsType
                if (this.zy.protype == 'OEM') {
                    this.isOemProduct = true;
                    this.chakanOemOrice();
                }
                console.log(rd.obj)
                for(var c in rd.obj){
                    this.instid = c;
                    this.gettable();
                }
            })
        },
        //查找定价
        query(){
            this.yaoshanchude = [];
            this.q.instid = this.instid;
            ss.chanpin.dingjiaselectPage(this.q).then(rd => {
                console.log(rd,'ssss??rd')
                this.q.total = rd.total;
                this.dingjiajihe = rd.records;
                this.jiazaibiao(rd.records);
            });
            //加载所有场景类型
            ss.bom.getAllSceneList().then(rd => {
                this.sceneList = rd.msg;
            });
        },
        //加载表
        jiazaibiao(q){

            this.tableData3 = [];

            for(var y in q){

                var list =  {

                    leixing: q[y].leltypecode==0?'区域':q[y].leltypecode==1?'经销商级别':q[y].leltypecode==2?'外贸':'',
                    jibie: q[y].type,//类型的值  级别或者区域
                    bizhong: q[y].currency,//币种
                    jiage: q[y].value,//定价金额
                    leixingflag: q[y].leltypecode,//类型的flag
                    id: q[y].id,//定价id主键
                    youxiaoqi: [q[y].startdate,q[y].effectivedate],//定价有效期
                    materialid: q[y].materialid,//物料id
                    bianlianga: q[y].leltypecode==0?'neibu_haiwai_area':q[y].leltypecode==1?'customer_group':q[y].leltypecode==2?'neibu_haiwai_area':'',
                    ispass:q[y].ispass,//审核标志   0 未通过   1 通过   2暂存  3提交审核中
                    nowshenpflag:q[y].nowshenpflag||'0',//审核标志   0 未通过   1 通过   2暂存  3提交审核中

                }

                this.tableData3.push(list)

            }

        },



        //更换级别区域
        changejibiequyu(q){

            console.log(q,'看看是多少')

             this.jiazaijibiequyu(q);

        },

        //取消
        quxiao(){
            this.$router.go(-1);
        },



        handleSelectionChange(val) {

            console.log(val)
            this.multipleSelection = val;
        },




        //更换数据字典名
        jiazaijibiequyu(q){


            if(q.leixing == 0){

                q.bianlianga='neibu_haiwai_area';

                q.leixingflag=0;



            }

            if(q.leixing == 1){//todo  级别配置？？

                // this.jibie = [];

                q.bianlianga='';//todo 级别配置的数据字典？？？

                q.leixingflag=1;



            }
            if(q.leixing == 2){

              q.bianlianga='neibu_haiwai_area';

              q.leixingflag=2;



            }
        },






        //取消按钮
        quxiaoanniu(){

            this.$router.go(-1);

        },

        tongguobohui(q){
            var shenPiEntity = {
                yewuzhujian: this.ywid,//业务主键
                taskid: this.taskid,//页面拿到的taskid
                msg: this.dingjiashenpi.shenheyijian,//  页面填写的审核意见
                jiediantiaojianming:'tongguoorbohui',//通过还是驳回的节点条件名字
                instid:this.instid,//选择要进入的审批版本id
                shifouquantongguo:'1',//是否全操作flag   0否  1是
                xiaoe:this.zy.xiaoe,
                jishu:this.zy.jishu,
                factory:this.zy.factory,
                typeUserCode:this.zy.typeUserCode,
                marketType:this.zy.marketType,
                sceneCode:this.zy.sceneCode,
                sceneName:this.zy.sceneName
            }
            // 通过还是驳回的flag  1驳回  2通过
            if(q==1){
                shenPiEntity.tongguoorbohui=1;
                shenPiEntity.optflag = '驳回';

            }else if(q==2){

                shenPiEntity.tongguoorbohui=2;
                shenPiEntity.optflag = '通过';

            }
            ss.chanpin.overSetPrice(shenPiEntity).then(rd => {
                if(rd.f==true){

                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        this.$router.go(-1);
                    })
                }
            })
        },
        getchang(code) {
            this.zy.sceneCode = code;
            const scene = _.find(this.sceneList,{sceneCode:code})
            this.zy.sceneName =  scene.sceneName;

        },

    },
}
</script>
<style scoped>
   .bbbb {
        padding-top: 5px;
    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .el-table .warning-row {
        background:#fef0f0;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
    .chanpin1 .h-formbLine .el-form-item__label{
        width: 29%;
        text-align: right;
    }
    .chanpin1 .h-formbLine .el-form-item__content{
        width: 71%;
    }
	.chanpin1 .h-formbLine .h-elformWrap-2{
		width: 33.33%;
	}
	.ljjtablepaddings4 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.w-elformWrap-3 {
		width: 100% !important;
	}
	.w-elformWrap-3 .el-form-item__label {
		width: 8% !important;
	}
	.w-elformWrap-3 .el-form-item__content {
		width: 92% !important;
	}
	.ljjtablepaddings4 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.ljjtablepaddings4 .el-range-editor.is-disabled{
		background-color: transparent;
		border-color: transparent;
	}
	.ljjtablepaddings4 .el-table tbody td .cell{
		padding: 0.03rem 0.1rem;
	}

	.ljj_selectdisblednone2 .el-input.is-disabled .el-input__inner{
		border-color: transparent;
	}
	.ljj_selectdisblednone2.el-select .el-input.is-disabled .el-input__inner:hover{
		border-color: transparent;
	}
	.ljj_selectdisblednone2 .el-input__suffix{
		display: none;
	}
</style>

